import {useRouterState} from '@tanstack/react-router'

import {toReactRouterLocation} from './use-location'

// Keeps the resolved source location while loading, then switches as soon as the destination matches render.
export const useRenderedLocation = () =>
  useRouterState({
    select: state =>
      toReactRouterLocation(state.isLoading ? (state.resolvedLocation ?? state.location) : state.location),
    structuralSharing: true,
  })
